<template lang='pug'>
  el-dialog(title="文件预览", size="full", :visible.sync="showPreview")      
    iframe(:src="url" style="width:100%;height:600px")
</template>

<script>
// Generated by CoffeeScript 2.3.0
var m;

export default m = {
  data: function() {
    return {
      url: '',
      showPreview: false
    };
  },
  methods: {
    show: function(url) {
      this.url = `${window.host}/${url}`;
      return this.showPreview = true;
    }
  }
};

// app.api.preview opts
// .then (@url) =>
//   console.log @url
</script>
